import { visit } from 'unist-util-visit';
import { definitions } from 'mdast-util-definitions';
import extend from 'extend';

const defaultTarget = '_blank';
const defaultProtocols = ['http', 'https', 'mailto'];

const isAbsoluteURL = url => /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);

/**
 * Remark plugin to add `target="_blank"` and `rel="nofollow noopener noreferrer"` to external links.
 *
 * Based on https://github.com/remarkjs/remark-external-links/blob/master/index.js.
 *
 * @param {object} options
 */
export default function externalLinks(options) {
  const opts = options || {};
  const target = opts.target;
  const protocols = opts.protocols || defaultProtocols;
  let content = opts.content;

  if (content && typeof content === 'object' && !('length' in content)) {
    content = [content];
  }

  return transform;

  function transform(tree) {
    const definition = definitions(tree);

    visit(tree, ['link', 'linkReference'], visitor);

    function visitor(node) {
      const ctx = node.type === 'link' ? node : definition(node.identifier);

      if (!ctx) return;

      let protocol = ctx.url.slice(0, ctx.url.indexOf(':'));
      let data;
      let props;

      if (isAbsoluteURL(ctx.url) && protocols.includes(protocol)) {
        data = node.data || (node.data = {});
        props = data.hProperties || (data.hProperties = {});

        if (target !== false) {
          props.target = target || defaultTarget;
        }

        props.rel = 'nofollow noopener noreferrer';

        if (content) {
          // `fragment` is not a known mdast node, but unknown nodes with
          // children are handled as elements by `mdast-util-to-hast`:
          // See: <https://github.com/syntax-tree/mdast-util-to-hast#notes>.
          node.children.push({
            type: 'fragment',
            children: [],
            data: { hName: 'span', hChildren: extend(true, content) }
          });
        }
      }
    }
  }
}
